import React from 'react';
import PropTypes from 'prop-types';
import { get } from '../Storage';
import Cashout from '../Widget/Cashout';
import axios from 'axios';
import CircularProgress from 'material-ui/CircularProgress';
import { ClassName } from 'mgToolsKit';
import Badge from 'material-ui/Badge';
import IconButton from 'material-ui/IconButton';
import * as Colors from 'material-ui/styles/colors';
import { MGSiteButton } from "mgUiKit";

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'TableTicketsListComponent';

var styles = AppSettings.styles;
/**
 * 
 * OBSOLETA E NON PIU' USATA
 * SOSTITUITA dal pacchetto dopo TicketList
 * 
 */
class TicketsList extends React.Component {
    constructor(props, context) {
        super(props);
        var canale = "";
        if(!AppSettings["perms"].terrestrialTicketList){
            canale = "online";
        }
        
        this.state = {
            error: false,
            errorMessage: "",
            data: [],
            showLoading: true,
            opened: false,
            filter: {
                type: "",
                canale: canale
            },
            cashoutAsk: null
        }
        this.getData = this.getData.bind(this);
        this.setFilter = this.setFilter.bind(this);

        this.timeDownloadTicket = Date.now();
    }

    componentDidMount() {
        this.getData();
    }

    getData(event) {
        if (this.state.opened) {
            this.setState({
                error: false,
                errorMessage: "",
                data: [],
                showLoading: true,
                opened: false
            });
            return;
        }
        this.refreshData();
    }

    refreshData() {
        this.setState({
            showLoading: true,
            opened: true
        });

        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();

        let startDate = dd + "-" + mm + "-" + yyyy;


        let endDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));

        dd = endDate.getDate();
        mm = endDate.getMonth() + 1;
        yyyy = endDate.getFullYear();
        endDate = dd + "-" + mm + "-" + yyyy;

        var url = AppSettings['env'].urlUserBoxTicketsList.replace('[START_DATE]', startDate).replace('[END_DATE]', endDate);
        // var dataPost = {
        //     "Username":"",
        //     "SessionToken":"",
        //     "WithTerrestrial": true,
        //     "WithProposal": true,
        //     "WithDetail": false,
        //     "WithFreebets": true
        // };
        axios.get(url)
            .then(({ data, status, statusText }) => {
                var showLoading = false;
                if (data.errors.length == 0) {
                    this.setState({
                        error: false,
                        errorMessage: "",
                        data: data.receipts,
                        showLoading: showLoading,

                    });
                } else {
                    this.setState({
                        error: true,
                        errorMessage: "La tua sessione è scaduta",
                        data: [],
                        showLoading: showLoading,
                        opened: true
                    });
                }
                this.timeDownloadTicket = Date.now() + (1000 * 30);
            })

            .catch( (error) => {
                this.setState({
                    error: true,
                    errorMessage: "",
                    data: [],
                    showLoading: false,
                    opened: true
                });
            });
    }

    setFilter(index) {
        var filter = this.state.filter;
        if (index == "removeFilter") {
            index = "";
            filter.canale = "";
        }
        if (index == "refresh") {
            // Scarico la lista se non sono passati _expireSeconds
            if (Date.now() < this.timeDownloadTicket) {
                return;
            }
            this.refreshData();
            return;
        }
        filter.type = index;
       
        this.setState({
            filter: filter
        }
        );
    };

    renderTabCanale(counter) {
        if(!AppSettings["perms"].terrestrialTicketList){
            return;
        }

        if(this.state.data.length  == 0){
            return;
        }

        let dataTe = this.state.data.filter(function(item){
            if(item.isTerrestrial){
                return true;
            }
            else{
                return false;
            }
        });

        let dataOnline = this.state.data.filter(function(item){
            if(!item.isTerrestrial){
                return true;
            }
            else{
                return false;
            }
        });
        if(dataTe.length > 0 && dataOnline.length > 0){
            
        }
        else{
            return;
        }

        var styleOnline = {};
        var styleAgenzia = {};
        if(this.state.filter.canale == "online"){
            styleOnline = styles.primaryContrastBackgroundColor;
        }
        if(this.state.filter.canale == "agenzia"){
            styleAgenzia = styles.primaryContrastBackgroundColor;
        }

        return (
            <div id="bar-tab-canale">
                <a style={styleOnline} onClick={this.setCanale.bind(this, "online")} href="#">Online</a>
                <a style={styleAgenzia} onClick={this.setCanale.bind(this, "agenzia")} href="#">Agenzia</a>
            </div>
        );
    }
    
    setCanale(canale){
        var filter = this.state.filter;
        filter.canale = canale;
        this.setState({
            filter: filter
        });
    }

    renderFilter(counter) {
        if (counter.total == 0) {
            return "";
        }

        var openedIcon = "";
        if (counter.opened > 0) {
            let iconStyleOpened = JSON.parse(JSON.stringify(styles.topFilterIconStyle));
            iconStyleOpened['color'] = Colors.blue500;
            let filerBadgeStyle = JSON.parse(JSON.stringify(styles.filerBadgeStyle));
            filerBadgeStyle['backgroundColor'] = Colors.blue500;
            openedIcon = <Badge badgeContent={counter.opened}
                style={styles.badgeNotifications}
                badgeStyle={filerBadgeStyle}>
                <IconButton iconClassName="fa fa-clock-o"
                    iconStyle={iconStyleOpened}
                    onClick={() => this.setFilter("opened")} />
            </Badge>;
        }

        var losingIcon = "";
        if (counter.losing > 0) {
            let iconStyleLosing = JSON.parse(JSON.stringify(styles.topFilterIconStyle));
            iconStyleLosing['color'] = Colors.red500;
            let filerBadgeStyle = JSON.parse(JSON.stringify(styles.filerBadgeStyle));
            filerBadgeStyle['backgroundColor'] = Colors.red500;
            losingIcon = <Badge badgeContent={counter.losing}
                style={styles.badgeNotifications}
                badgeStyle={filerBadgeStyle}>
                <IconButton iconClassName="fa fa-frown-o"
                    iconStyle={iconStyleLosing}
                    onClick={() => this.setFilter("losing")} />
            </Badge>;
        }

        var winnigIcon = "";
        if (counter.winning > 0) {
            let iconStyleWinning = JSON.parse(JSON.stringify(styles.topFilterIconStyle));
            iconStyleWinning['color'] = Colors.green500;
            let filerBadgeStyle = JSON.parse(JSON.stringify(styles.filerBadgeStyle));
            filerBadgeStyle['backgroundColor'] = Colors.green500;
            winnigIcon = <Badge badgeContent={counter.winning}
                style={styles.badgeNotifications}
                badgeStyle={filerBadgeStyle}>
                <IconButton iconClassName="fa fa-check"
                    iconStyle={iconStyleWinning}
                    onClick={() => this.setFilter("winning")} />
            </Badge>;
        }

        var refreshIcon = <IconButton iconClassName="fa fa-refresh" 
            iconStyle={styles.iconFilter}
            onClick={() => this.setFilter("refresh")} />;


        var iconStyleAbort = JSON.parse(JSON.stringify(styles.topFilterIconStyle));
        iconStyleAbort['color'] = Colors.grey500
        if (this.state.filter.type == "" && this.state.filter.canale == "") {
            iconStyleAbort['opacity'] = "0.2"; 
        }
        
        var abortIcon = <IconButton iconClassName="fa fa-times"
            iconStyle={iconStyleAbort}
            onClick={() => this.setFilter("removeFilter")} />;

            return (
                <div id="bar-bet-icons">
                    {openedIcon}
                    {winnigIcon}
                    {losingIcon}
                    {refreshIcon}
                    {abortIcon}
                </div>
            );
    }

    renderData() {
        if (this.state.showLoading) {
            return (
                <CircularProgress style={styles.loadingIcon} />
            );
        }

        var data;
        var counter = {
            opened: 0,
            losing: 0,
            winning: 0,
            total: 0
        };
        counter.total = this.state.data.length;

        let dataTe = this.state.data.filter(function(item){
            if(item.isTerrestrial){
                return true;
            }
            else{
                return false;
            }
        });
        let colCanaleEnabled = false;
        if(dataTe.length > 0 ){
            colCanaleEnabled = true;
        }

        if (this.state.data.length > 0) {
            // Proposte di gioco
            var currentDate = "";
            var dataProposal = this.state.data.map(function (ticket, i) {
                if(ticket.isProposal){
                    var key = ticket.ticketId;

                    var className = ["mg-bet-" + ticket.status];
                    className.push("mg-bet-online");
                    className.push("mg-bet-proposal");

                    var ticketDetail = () => {
                        window.open(ticket.link, "_blank");
                    }

                    var exclude = false;
                    if ((this.state.filter.type == "" || this.state.filter.type == ticket.status)){
                        if(this.state.filter.canale == "agenzia" && !ticket.isTerrestrial){
                            exclude = true;
                        }
                        if(this.state.filter.canale == "online" && ticket.isTerrestrial){
                            exclude = true;
                        }
                    }
                    else {
                        exclude = true;
                    }
                    
                    if(exclude){
                        if(this.state.filter.canale != "" && this.state.filter.type == ""){
                            switch (ticket.status) {
                                case 'opened':
                                    counter.opened--;
                                    break;
                                case 'losing':
                                    counter.losing--;
                                    break;
                                case 'winning':
                                    counter.winning--;
                                    break;
                            }
                        }
                        return null;
                    }

                    var descrizione = "";
                    switch (ticket.status) {
                        case 'opened':
                            descrizione = "In valutazione";
                            break;
                        case 'cancelled':
                            descrizione = "Non accettata";
                            break;
                    }

                    var rows = [];
                    if(currentDate == ""){
                        currentDate = "proposal";
                        var keyData = key + "_data";
                        var  rowDate = 
                            <tr className="mg-bet-data" key={keyData}>
                                <td colSpan="5">Accettazione</td>
                            </tr>;
                        rows.push(rowDate)
                    }

                    var title = "Visualizza lo stato della tua puntata";
                    var rowTicket = 
                        <tr key={key} className={ClassName(className)} onClick={ticketDetail} title={title}>
                            <td className="mg-bet-data">{descrizione}</td>
                            <td className="mg-bet-giocata"><strong>{ticket.amount}</strong></td>
                            <td className="mg-bet-vincita"><strong>{ticket.risk}</strong></td>
                            {
                            colCanaleEnabled != "" ?
                                <td className="mg-bet-canale mg-icona-canale"></td>
                                : null
                            }
                        </tr>;
                    rows.push(rowTicket);
                }

                return rows;

            }.bind(this));
           
            var currentDate = "";
            var dataTickets = this.state.data.map(function (ticket, i) {
                var parzializzazione = ticket.byProposal && ticket.isReply && ticket.isPartialAmount;
                if(!ticket.isProposal){
                    var key = ticket.ticketId;
                    var risk = ticket.risk;
                    var paid = ticket.paidAmount;
                    switch (ticket.status) {
                        case 'opened':
                            var paid = "-";
                            counter.opened++;
                            break;
                        case 'losing':
                            var paid = "-";
                            counter.losing++;
                            break;
                        case 'winning':
                            var paid = risk;
                            counter.winning++;
                            break;
                    }

                    var className = ["mg-bet-" + ticket.status];
                    var titleCanale;
                    if(ticket.isTerrestrial){
                        className.push("mg-bet-agenzia");
                        titleCanale = "Agenzia";
                    }
                    else{
                        className.push("mg-bet-online");
                        if(ticket.isFreebet){
                            className.push("mg-bet-freebet");
                        }
                        titleCanale = "Online";
                    }
                    if(ticket.byProposal){
                        className.push("mg-bet-byproposal");
                    }
                    if(parzializzazione){
                        className.push("bs-by-partial");
                    }

                    if(ticket.byCashout){
                        className.push("bs-by-partial");
                        className.push("bs-by-cashout");
                    }
                    let cashOutEnable = true;
                    let internalCashoutEnable = false;
                    // if(cashOutEnable && ticket.status == 'opened' && !ticket.isTerrestrial && !ticket.isFreebet && !ticket.isProposal){
                    //     internalCashoutEnable = true;
                    // }

                    
                    var ticketDetail = () => {
                        window.open(ticket.link, "_blank");
                    }

                    var exclude = false;
                    if ((this.state.filter.type == "" || this.state.filter.type == ticket.status)){
                        if(this.state.filter.canale == "agenzia" && !ticket.isTerrestrial){
                            exclude = true;
                        }
                        if(this.state.filter.canale == "online" && ticket.isTerrestrial){
                            exclude = true;
                        }
                    }
                    else {
                        exclude = true;
                    }
                    
                    if(exclude){
                        if(this.state.filter.canale != "" && this.state.filter.type == ""){
                            switch (ticket.status) {
                                case 'opened':
                                    counter.opened--;
                                    break;
                                case 'losing':
                                    counter.losing--;
                                    break;
                                case 'winning':
                                    counter.winning--;
                                    break;
                            }
                        }
                        return null;
                    }

                    var [data, ora] = ticket.date.split(" ");
                    var oraStr = ora.substring(0,5);
                    var rows = [];
                    
                    if(data != currentDate){
                        currentDate = data;
                       
                        var keyData = key + "_data";
                        var keyDataHead = key + "_dataH";
                        var  rowDate = 
                            <>
                                <tr className="mg-bet-data" key={keyData}>
                                    <td colSpan="5">{data}</td>
                                </tr>
                                <tr key={keyDataHead} className="userBoxBetTicket--head">
                                    <th className="mg-bet-status"></th>
                                    {/* <th className="mg-bet-data" colspan="2"></th> */}
                                    <th className="mg-bet-giocata">Puntata</th>
                                    <th className="mg-bet-vincita">Vincita</th>
                                    {
                                        colCanaleEnabled ?<th className="mg-bet-canale">Canale</th>
                                    :null}
                                     <th className="mg-bet-operation"></th>
                                </tr>
                            </>;
                        rows.push(rowDate)
                    }
                   
                    let htmlAmount =  <span className="mg-info-amount"  title="Importo giocato"><strong>{ticket.amount}</strong></span>;
                    if(parzializzazione){
                        let titleInitialAmount = "Importo piazzato dall'utente "+ ticket.initialAmount + ", importo accettato " +ticket.amount +" biglietto venduto automaticamete a " + ticket.amount;
                        let titlelAmount = "Importo accettato";
                        htmlAmount =   
                            <>
                                <span className="mg-info-amount mg-variazione-importo" title={titleInitialAmount}><strong>{ticket.initialAmount}</strong></span>
                                <span className="mg-info-amount" title={titlelAmount}><strong>{ticket.amount}</strong></span>
                            </>;
                    }

                    let htmlRisk =   <strong>{risk}</strong>;
                    if(ticket.byCashout){
                        let titleInitialAmount = "Vincita iniziale del ticket " + ticket.initialAmount + ", Vincita cashout accettata dall'utente " + ticket.risk;
                        let titlelAmount = "Importo cash out";
                        
                        htmlRisk =   
                            <>
                                <span className="mg-info-amount mg-variazione-importo" title={titleInitialAmount}><strong>{ticket.initialAmount}</strong></span>
                                <span className="mg-info-amount" title={titlelAmount}><strong>{ticket.risk}</strong></span>
                            </>;
                    }

                    var title = "Visualizza dettagli della scommessa";
                    let keycashout = key + "_cashout";
                    
                    
                    var rowTicket = 
                    <tr key={key} className={ClassName(className)} onClick={ticketDetail} title={title}>
                        <td className="mg-icona-status"></td>
                        {/* <td className="mg-bet-ora">{oraStr}</td> */}
                        <td className="mg-bet-giocata">
                            {htmlAmount}
                        </td>
                        <td className="mg-bet-vincita">{htmlRisk}</td>
                        {
                            colCanaleEnabled != "" ?<td className="mg-bet-canale mg-icona-canale"></td>:null
                        }
                         <td className="mg-bet-operation">
                            {internalCashoutEnable ?<Cashout askCashout={this.openCashout.bind(this)} key={keycashout} data={ticket}/>: ""}
                         </td>
                    </tr>;
                    rows.push(rowTicket);

                    
                    if(this.state.cashoutAsk != null &&
                        this.state.cashoutAsk.betId == ticket.betId){
                        let keyCashout = key + "_cashouotask";
                        let rowContainer = <tr key={keyCashout} className="mg-bet-op-container">
                            <Cashout type="confirm" data={ticket}/>
                        </tr>;
                        rows.push(rowContainer);
                    }
                    
                }

                return rows;

            }.bind(this));


            data = dataProposal.concat(dataTickets);
            data = data.filter(function(item)  {
                if(item != null){
                    return true;
                }
                else{
                    return false;
                }
            });
            if(data.length == 0){
                data = <tr key="noRow">
                          <td colSpan="5" className="userBoxBetTicket--noresult">Il filtro applicato non ha prodotto risultati</td>
                       </tr>;
            }
        }
        else {
            data = <tr key="noRow">
                    <td colSpan="5" className="userBoxBetTicket--noresult">Il filtro applicato non ha prodotto risultati</td>
                  </tr>;
        }

        var openTutteLeGiocate = (e) => {
            this.context.openLinkPopup(e, AppSettings.homeRealm + 'betMg/betReport');
        }

        return (
            <div className="mg-user-widget">
                    {this.renderTabCanale()}
                    {this.renderFilter(counter)}
                <table className="userBoxTable userBoxBetTicket">
                    <tbody>
                        {data}
                    </tbody>
                </table>              
                <MGSiteButton
                    title="Tutte le giocate"
                    class=""
                    label="Tutte le giocate"
                    disabled={false}
                    primary={false}
                    isButton={true}
                    fullWidth={true}
                    actionFunc={openTutteLeGiocate}
                />

            </div>
        );
    }
    render() {
        return this.renderData();
    }

    openCashout(ticket){
        this.setState({
            cashoutAsk: ticket
        });
    }
}
TicketsList.displayName = componentName;

// PropTypes validation
TicketsList.propTypes = {
};

// default props
TicketsList.defaultProps = {
};

TicketsList.contextTypes = {
    openLinkPopup: PropTypes.func
}

export default TicketsList;